import { HttpInterceptorFn, provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  EnvironmentProviders,
  Provider,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { OidcSecurityService, provideAuth } from 'angular-auth-oidc-client';
import { firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';
import { mg3pOidcConfig } from './core/auth/auth.config';
import { AuthService } from './core/auth/services/auth.service';
import { MockAuthService } from './core/auth/services/mock-auth.service';
import { authTokenInterceptor } from './core/http/interceptors/auth-token.interceptor';
import { correlationInterceptor } from './core/http/interceptors/correlation.interceptor';
import { auditInterceptor } from './core/audit/audit.interceptor';
import { mockApiInterceptor } from './core/mock/mock-api.interceptor';
import { appRoutes } from './app.routes';

// Modo mock (npm run start:mock): autenticação e API simuladas, sem Keycloak/backend.
const interceptors: HttpInterceptorFn[] = environment.mock
  ? [mockApiInterceptor, correlationInterceptor, auditInterceptor]
  : [correlationInterceptor, authTokenInterceptor, auditInterceptor];

// checkAuth() precisa rodar uma única vez, no bootstrap: se cada guard da rota
// (authGuard, roleGuard) chamar checkAuth() por conta própria, ambos tentam trocar
// o mesmo authorization code (uso único) e o segundo falha com invalid_grant no
// Keycloak. Os guards apenas leem o estado já resolvido via AuthService.isAuthenticated().
const authProviders: (Provider | EnvironmentProviders)[] = environment.mock
  ? [{ provide: AuthService, useFactory: () => new MockAuthService() as unknown as AuthService }]
  : [
      provideAuth({ config: mg3pOidcConfig }),
      provideAppInitializer(() => firstValueFrom(inject(OidcSecurityService).checkAuth())),
    ];

export const appConfig: ApplicationConfig = {
  providers: [
    ...authProviders,
    provideHttpClient(withInterceptors(interceptors)),
    provideRouter(appRoutes),
  ],
};
